<div class="filter-modal-container">
  <div class="filter-header">Filters</div>
  <div class="filter-container">
    <ng-container *ngIf="openForm">
      <form [formGroup]="filterForm" class="filter-form">
        <ng-container>
          <emerald-dropdown
            [label]="'Month'"
            [outlined]="true"
            [options]="monthYearOptions"
            [id]="'monthYear_select'"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
            formControlName="monthYear"
          ></emerald-dropdown>
          <emerald-dropdown
            [label]="'LOB'"
            [outlined]="true"
            [options]="lobOptions"
            [id]="'lob_select'"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
            formControlName="lob"
          ></emerald-dropdown>
          <emerald-dropdown
            [label]="'Project Name'"
            [outlined]="true"
            [options]="projectNameOptions"
            [id]="'projectName_select'"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
            formControlName="projectName"
          ></emerald-dropdown>
          <emerald-dropdown
            [label]="'Vendors'"
            [outlined]="true"
            [options]="vendorOptions"
            [id]="'vendor_select'"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
            formControlName="vendor"
          ></emerald-dropdown>
          <emerald-dropdown
            [label]="'Job Title'"
            [outlined]="true"
            [options]="jobTitleOptions"
            [id]="'jobTitle_select'"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
            formControlName="jobTitle"
          ></emerald-dropdown>
        </ng-container>
      </form>
    </ng-container>
    <ng-container actions>
      <div class="button-container">
        <span class="mdc-dialog__button">
          <emerald-button [type]="'Secondary'" (onClick)="reset()"
            >Reset</emerald-button
          >
        </span>
        <span class="mdc-dialog__button">
          <emerald-button color="primary" (click)="apply()" label="Apply">
            Apply
          </emerald-button>
        </span>
      </div>
    </ng-container>
  </div>
</div>
